// extracted by mini-css-extract-plugin
module.exports = {"abstract":"ArticleAbstract_abstract__u1zQK","abstractDefaultLocale":"ArticleAbstract_abstractDefaultLocale__Dyi5z"};